import React from 'react';
import { USER } from "../../services/actions";
import { useDispatch, useSelector } from "react-redux";
import RFG from '../../libs/inputs/RFG';
import { useForm } from 'react-hook-form';
import {
    Badge,
    Card,
    CardContent,
    Typography,
    Box,
    LinearProgress,
    Grid,
    IconButton,
    Avatar,
    Chip,
} from "@mui/material";

import { BsEnvelopeFill, BsFillTelephoneFill } from "react-icons/bs";
import ImageResizer from '../extra/ImageResizer';

export default function Profile() {
    let dispatch = useDispatch()
    let user = useSelector((state) => state?.loginState.auth)
    let userState = useSelector((state) => state?.userState)
    const { handleSubmit, control, reset, setValue } = useForm({ defaultValues: user, mode: "all" })
    const passwordForm = useForm({ mode: "all", defaultValues: { id: user.id, username: user.username } });
    const { handleSubmit: handlePasswordSubmit, control: passwordControl } = passwordForm;

    React.useEffect(() => {
        // dispatch({ type: `${USER}_GET`, payload: user?.id });
        // console.log("USER", user)
    }, [])

    React.useEffect(() => {
        console.log("USER STATE", userState.data)
        reset(userState?.data?.data)
    }, [userState])

    const onSubmit = (data) => {
        if (!data['avatar'] || String(data['avatar']).startsWith("http")) {
            delete data['avatar']
        }
        let payload = {}
        const f = ["id", "avatar", "first_name", "last_name", "email", "phone"]
        f.map((key) => {
            if (data[key] && data[key] != "") {
                payload[key] = data[key]
            }
        })
        console.log("Submiteed", payload)
        dispatch({
            type: `${USER}_PATCH`, payload: payload, callback: (resp) => {
                dispatch({ type: "LOGIN_AUTH", payload: resp, local: true })
            }
        });
    }
    const changePassword = (data) => {
        let payload = {}
        const f = ["id", "username", "passwod"]
        f.map((key) => {
            if (data[key] && data[key] != "") {
                payload[key] = data[key]
            }
        })
        dispatch({
            type: `${USER}_PATCH`, payload: payload, callback: (resp) => {
                dispatch({ type: "LOGIN_AUTH", payload: resp, local: true })
            }
        });
    }

    return (
        <>
            <Grid container spacing={1} sx={{ p: 1 }}>
                <Grid size={{ sm: 12, md: 4, xl: 4 }}>
                    <Card sx={{ p: 2, width: 1 }}>
                        <Typography sx={{ mb: 3 }}>My Profile</Typography>
                        <Box display={'flex'} sx={{ my: 2 }}>
                            <Avatar
                                name="avatar"
                                src={user?.avatar}
                                icon={<Avatar label="A" size="xlarge" shape="circle" className="mb-3" />}
                                shape="circle"
                                sx={{ width: 100, height: 100 }}
                            />
                            <Box sx={{ px: 3 }}>
                                <Box>
                                    <Typography fontSize={26} fontWeight={700} component={'h2'}>{user?.first_name}</Typography>
                                </Box>
                                <Badge value={user?.main_role} size="small" severity="warning" />
                            </Box>
                        </Box>
                        <Box sx={{ py: 3, px: 4 }}>
                            <Box display={'flex'} justifyContent={'space-between'}>
                                <Typography fontSize={14}>Firstname</Typography> <Typography fontSize={12} color="green"> {user.first_name}</Typography>
                            </Box>
                            <Box sx={{ py: 1 }} display={'flex'} justifyContent={'space-between'}>
                                <Typography fontSize={14}>Lastname</Typography> <Typography fontSize={12} color="green"> {user.last_name}</Typography>
                            </Box>
                            <Box sx={{ py: 1 }} display={'flex'} justifyContent={'space-between'}>
                                <Typography><BsFillTelephoneFill /></Typography> <Typography fontSize={12} color="green"> {user.phone}</Typography>
                            </Box>
                            <Box display={'flex'} justifyContent={'space-between'}>
                                <Typography>< BsEnvelopeFill /></Typography> <Typography fontSize={12} color="green"> {user.email}</Typography>
                            </Box>
                            <Box sx={{ py: 1 }}>
                                {user.is_active ? <Chip size="small" variant='success' label="active" /> : <Chip size="small" variant='damger' label="Deactive" />}
                            </Box>
                        </Box>
                        <Box sx={{ p: 1 }}>
                            <form onSubmit={handlePasswordSubmit(changePassword)}>
                                <RFG name="username" label="Email" control={passwordControl} rules={{ required: true }}>
                                    <input />
                                </RFG>
                                <RFG name="password" label="Password" control={passwordControl} rules={{ required: true }}>
                                    <input />
                                </RFG>
                                <Box sx={{ py: 2 }}>
                                    <input type="submit" className={'btn-primary'} />
                                </Box>
                            </form>
                        </Box>
                    </Card>
                </Grid>
                <Grid size={{ sm: 12, md: 8, xl: 8 }}>
                    <Card sx={{ p: 2, width: 1, height: '86vh' }}>
                        <Typography sx={{ mb: 3 }}>Edit Profile</Typography>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid size={{ md: 6 }}>
                                    <Box sx={{ py: 2 }}>
                                        <ImageResizer onChange={(bs64) => setValue("avatar", bs64)} />
                                    </Box>
                                    <RFG name="id" control={control}>
                                        <input type="hidden" />
                                    </RFG>
                                    <RFG name="first_name" label="First Name" control={control} rules={{ required: true }} className="mb-2">
                                        <input />
                                    </RFG>
                                    <RFG name="last_name" label="Last Name" control={control} rules={{ required: true }}>
                                        <input />
                                    </RFG>
                                </Grid>
                                <Grid size={{ md: 6 }}>

                                    <RFG name="email" label="Email" control={control} rules={{ required: true }}>
                                        <input />
                                    </RFG>
                                    <RFG name="phone" label="Phone" control={control} rules={{ required: true }}>
                                        <input />
                                    </RFG>
                                    <Box sx={{ py: 2 }}>
                                        <input type="submit" className={'btn-primary'} />
                                    </Box>

                                </Grid>
                            </Grid>
                        </form>
                        {/* {userState.message} */}
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}